import { Spinner } from '@99designs/common/components/Spinner';
import React, { useEffect, useState } from 'react';

type Props = {
    url: string;
    title: string;
};

const LoadableImage: React.FunctionComponent<Props> = props => {
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => setImageLoaded(false), [props.url]);

    return (
        <>
            {!imageLoaded && (
                <div className="loadable-image__spinner">
                    <Spinner />
                </div>
            )}
            <img
                src={props.url}
                className="loadable-image__image"
                alt={props.title}
                onLoad={() => setImageLoaded(true)}
                style={{ opacity: Number(imageLoaded) }}
            />
        </>
    );
};

export default LoadableImage;
